import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { r as remCalc } from './index5.js';
import { D as DomService, T as TrackingService } from './index3.js';
import { A as AdobeTracking } from './index7.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

var Alignments;
(function (Alignments) {
    Alignments["DEFAULT"] = "";
    Alignments["LEFT"] = "left";
    Alignments["CENTER"] = "center";
    Alignments["RIGHT"] = "right";
})(Alignments || (Alignments = {}));

const rocheSocialMediaCss = ":host{display:block;margin-top:3rem;margin-top:0;position:relative;display:block;height:auto;margin:4rem 0 0 0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .social-media-toolbar{position:relative}:host .social-media-overline{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem;margin:0 0 2rem 0}@media (min-width: 48rem){:host .social-media-overline{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}:host .social-media-links-list{display:flex;flex-wrap:wrap;align-items:center;margin:0;padding:0;list-style:none}:host .social-media-links-list .social-media-link-wrapper{position:relative;text-align:center;margin-right:1.5rem;text-indent:0;overflow:visible}:host .social-media-links-list .social-media-link-wrapper:hover roche-icon{fill:#0b41cd}:host .social-media-links-list .social-media-link-wrapper roche-icon{display:flex;align-items:center;justify-content:center;fill:#544f4f;cursor:pointer}:host .social-media-links-list .social-media-link{height:100%;width:100%;position:absolute;top:0;left:0;display:inline-block;transition:0.2s all;cursor:pointer}:host .align-left .social-media-overline{text-align:left}:host .align-left .social-media-links-list{justify-content:left}:host .align-center .social-media-overline{text-align:center}:host .align-center .social-media-links-list{justify-content:center}:host .align-right .social-media-overline{text-align:right}:host .align-right .social-media-links-list{justify-content:right}";
const RocheSocialMediaStyle0 = rocheSocialMediaCss;

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const url = window.location.toString().split('#')[0];
const RocheSocialMedia$1 = /*@__PURE__*/ proxyCustomElement(class RocheSocialMedia extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.overline = undefined;
        this.align = Alignments.DEFAULT;
        this.disableFacebook = false;
        this.disableTwitter = false;
        this.disableLinkedin = false;
    }
    get socialMediaItems() {
        return [
            {
                'data-social': 'email',
                icon: 'mobile',
                href: `mailto:?subject=${document.title}&body=${url}`,
                shouldRender: false,
            },
            {
                'data-social': 'facebook',
                icon: 'facebook',
                href: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                shouldRender: !this.disableFacebook,
            },
            {
                'data-social': 'twitter',
                icon: 'twitter',
                href: `http://twitter.com/intent/tweet?url=${url}`,
                shouldRender: !this.disableTwitter,
            },
            {
                'data-social': 'linkedin',
                icon: 'linkedin',
                href: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
                shouldRender: !this.disableLinkedin,
            },
            {
                'data-social': 'xing',
                icon: 'mobile',
                href: `https://www.xing.com/spi/shares/new?url=${url}`,
                shouldRender: false,
            },
            {
                'data-social': 'copy',
                icon: 'copy-link',
                shouldRender: true,
            },
        ];
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    componentWillRender() {
        if (this.align === Alignments.DEFAULT) {
            this.align = DomService.isRtl(this.element) ? Alignments.RIGHT : Alignments.LEFT;
        }
    }
    render() {
        const classNames = {
            'social-media-toolbar': true,
            'align-left': this.align === Alignments.LEFT,
            'align-center': this.align === Alignments.CENTER,
            'align-right': this.align === Alignments.RIGHT,
        };
        if (DomService.getGlobalConfig().isShareHidden === 'true') {
            return null;
        }
        return (h(Host, null, h("div", { class: classNames }, this.overline
            && h("div", { class: "social-media-overline" }, this.overline), h("ul", { class: "social-media-links-list" }, this.socialMediaItems.map((item, index) => {
            const { shouldRender, icon } = item, linkAttributes = __rest(item, ["shouldRender", "icon"]);
            if (!shouldRender) {
                return null;
            }
            return (h("li", { class: "social-media-link-wrapper", key: index }, h("roche-icon", { icon: icon, height: `${remCalc(24)}rem` }), h("a", Object.assign({ class: "social-media-link", target: "_blank", rel: "noreferrer", onClick: this.onClick }, linkAttributes))));
        })))));
    }
    static trackClick(event, socialNetwork) {
        var _a, _b;
        TrackingService.push({
            event: 'share',
            component_name: 'roche-social-media',
            additionalParameters: Object.assign({ social_network: socialNetwork }, TrackingService.getParentAwareTrackingInfo(event)),
        });
        const adobeTrackingData = {
            innerText: '',
            url: (_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.href,
            position: 'RocheSocialMedia',
            type: 'Link',
            socialMedia: (_b = event.currentTarget) === null || _b === void 0 ? void 0 : _b.dataset.social,
            socialInteraction: 'Share',
        };
        AdobeTracking(adobeTrackingData, 'defaultLinkClick');
    }
    onClick(event) {
        const socialNetwork = this.getAttribute('data-social');
        if (socialNetwork === 'copy') {
            navigator.clipboard.writeText(url);
        }
        RocheSocialMedia.trackClick(event, socialNetwork);
    }
    get element() { return this; }
    static get style() { return RocheSocialMediaStyle0; }
}, [1, "roche-social-media", {
        "overline": [1],
        "align": [1],
        "disableFacebook": [4, "disable-facebook"],
        "disableTwitter": [4, "disable-twitter"],
        "disableLinkedin": [4, "disable-linkedin"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-social-media", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-social-media":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSocialMedia$1);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheSocialMedia = RocheSocialMedia$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSocialMedia, defineCustomElement };

//# sourceMappingURL=roche-social-media.js.map